import { User } from '@/model/user';
import { UserService } from '@/service/user.service';
import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { SearchComponent } from '../search/search.component';

@Component({
  selector: 'app-navigation',
  imports: [
    MatToolbar,
    MatIcon,
    MatMenu,
    MatButtonModule,
    MatMenuModule,
    SearchComponent,
    RouterLink,
    MatSidenavModule,
    NgOptimizedImage
],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: true,
})
export class NavigationComponent {
  hasCompanyRole = false;
  hasAdminRole = false;
  hasAdvisoryBoardRole = false;
  isMenuOpen = false;
  showMobileSearchBar = true;
  isAuthenticated = false;
  user: User | null = null;
  constructor(
    private keycloakService: KeycloakService,
    private userService: UserService,
    private router: Router,
  ) {
    this.router.events.subscribe(() => {
      this.checkRoute();
    });
    const userRoles = this.keycloakService.getUserRoles();
    this.hasCompanyRole = userRoles.includes('company');
    this.hasAdminRole = userRoles.includes('admin');
    this.hasAdvisoryBoardRole = userRoles.includes('advisory-board');
    this.isAuthenticated = this.keycloakService.isLoggedIn();

    this.userService.getUserInfo().subscribe((user) => {
      this.user = user;
      if (user) {
        this.hasAdvisoryBoardRole = user.isAdvisoryboard ?? false;
      } else {
        this.hasAdvisoryBoardRole = false;
      }
    });
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  private checkRoute() {
    const currentRoute = this.router.url;
    this.showMobileSearchBar = !(
      currentRoute.includes('add-offer') ||
      currentRoute.includes('add-offers') ||
      currentRoute.includes('edit') ||
      currentRoute.includes('feedback/') ||
      currentRoute.includes('company-management') ||
      currentRoute.includes('profile') ||
      currentRoute.includes('sondisa')
    );
  }

  logout() {
    this.keycloakService.logout();
  }

  login() {
    this.keycloakService.login();
  }

  register() {
    this.keycloakService.register();
  }
}
